import React from 'react';
import ShareExperienceSignUpView from './ShareExperienceSignUpView';

export function ShareExperienceSignUpContainer() {
	return (
		<div>
			<ShareExperienceSignUpView />
		</div>
	);
}
